import { INTENT_TYPE } from '../../constants';
import { resolveCueFamily } from '../features/cue-family';
import { ACTION_CUES } from '../pack/lexicons';
import { type ConvergenceRule, type FeatureContext } from '../types';

/**
 * `C-ACTION` (priority 960) — an explicit request to change something.
 *
 * The highest-confidence Chat family: `create a launch page`, `archive the old roadmap`.
 * An action verb at the first semantic position with a real operand is about as
 * unambiguous as browser-side intent gets.
 *
 * The browser deliberately does **not** infer artefact type or authorization. It decides
 * the destination; whether the user may actually archive that page is Chat's problem.
 */
export const matchesAction = (features: FeatureContext): boolean =>
	resolveCueFamily(features, { cues: ACTION_CUES }) !== null;

export const actionRule: ConvergenceRule = {
	type: INTENT_TYPE.CHAT,
	pattern: 'ACTION_REQUEST',
	matches: matchesAction,
};
